import Reflux from 'reflux'
export default Reflux.createActions(['commandArgMapEditors','getSelectRecordsKey',"getSelectRecords",
				"callComponentFunc","diaLogMapEditors",'selectAllRecords','selectRecords2','reverseSelectedRecords','buttonShortCut','getColumnLengthProperties']);


// WEBPACK FOOTER //
// ./src/actions/CommandActions.js